import {registerFragment} from '@neptune/cx/registry';
import './styles.scss';
import {DisposalSet, select} from '@neptune/cx/utils';
import {Accordion} from '../cbdce-accordion';

export class AccordionSet {
    isMutex: boolean = false;
    instanceInitialized: boolean = false;
    accordionSetEl: HTMLDivElement;
    accordions: Accordion[] = [];
    firstOpenAccordion: Accordion | null = null;

    static #registry: WeakMap<HTMLDivElement, AccordionSet> = new WeakMap();

    static getAccordionSetInstance(accordionSetEl: HTMLDivElement): AccordionSet{
        let instance = AccordionSet.#registry.get(accordionSetEl);

        if (!instance) {
            instance = new AccordionSet(accordionSetEl);
            AccordionSet.#registry.set(accordionSetEl, instance);
        }
        return instance;
    }
    static registerAccordion(accordionSetEl: HTMLDivElement, accordion: Accordion): AccordionSet {
        const instance = AccordionSet.getAccordionSetInstance(accordionSetEl);
        instance.add(accordion);

        return instance;
    }

    constructor(accordionSetEl: HTMLDivElement) {
        this.accordionSetEl = accordionSetEl;
        if (accordionSetEl.classList.contains('cbdce-accordion-set--mutex')) {
            this.isMutex = true;
        }
    }

    onOpen(accordion: Accordion) {
        if (!this.isMutex) return;
        else {
            this.accordions.forEach((acc) => {
                if (acc !== accordion) {
                    acc.close();
                }
            });
        }
    }

    add(accordion: Accordion) {
        // console.log('add');
        this.accordions.push(accordion);
        if (this.instanceInitialized) {
            // console.log('add.init');
            this.initAccordion(accordion);
        }
    }

    init() {
        for (const accordion of this.accordions) {

            this.initAccordion(accordion);
        }
        this.instanceInitialized = true;
    }

    initAccordion(accordion: Accordion) {
        if (this.isMutex) {
            if (this.firstOpenAccordion == null && accordion.isOpen) {
                this.firstOpenAccordion = accordion;
                // console.log('forced open');
                accordion.open(true, accordion.noInitialResize);
            } else {
                // console.log('forced close');
                accordion.close(true);
            }
        }
    }
}



registerFragment('cbdce-accordion-set', (fragmentElement, configuration, meta) => {
    const accordionSetEl = select<HTMLDivElement>(fragmentElement, '.cbdce-accordion-set');

    const accordion = AccordionSet.getAccordionSetInstance(accordionSetEl);
    accordion.init();
});

if (import.meta.hot) {
    import.meta.hot.decline();
}
